import { isValidRoutingNumber } from 'platform/forms/validations';

export const validateRoutingNumber = (errors, routingNumber) => {
  if (!routingNumber) return;
  const cleanValue = routingNumber.toString().replace(/[^\d]/g, '');
  if (!isValidRoutingNumber(cleanValue)) {
    errors.addError('Enter a valid 9-digit routing number');
  }
};

const isValidAccountNumber = accountNumber => {
  return /^[a-z0-9]{5,17}$/i.test(accountNumber.trim());
};

export const validateBankAccountNumber = (
  errors,
  accountNumber,
  _formData,
  _schema,
  errorMessages,
) => {
  if (!accountNumber) return;
  if (!isValidAccountNumber(accountNumber)) {
    errors.addError(
      errorMessages?.pattern ||
        'Enter a valid bank account number up to 17 characters',
    );
  }
};

export const BANK_NAME_MAX_LENGTH = 1000;
const DISALLOWED_CHARS = /[<>{}[\]\\^`|~$%*=_@#]/;

export const validateBankName = (
  errors,
  bankName,
  _formData,
  _schema,
  errorMessages,
) => {
  if (bankName === undefined || bankName === null) return;
  if (typeof bankName !== 'string') {
    errors.addError('Enter a valid bank name');
    return;
  }
  if (!bankName.trim()) {
    errors.addError(errorMessages?.required || 'Enter a bank name');
    return;
  }
  if (bankName.trim().length > BANK_NAME_MAX_LENGTH) {
    errors.addError(
      `Bank name must be ${BANK_NAME_MAX_LENGTH} characters or less`,
    );
    return;
  }
  if (DISALLOWED_CHARS.test(bankName)) {
    errors.addError('Enter a valid bank name');
  }
};
